<template>
  <div class="upload-image-container">
    <div v-for="(image, index) in photos" :key="index" class="image-item">
      <img :src="image" class="preview-image">
      <i class="el-icon-close delete-icon" @click="removeImage(index)"></i>
    </div>

    <div v-if="photos.length < imageCount" class="upload-button" @click="triggerUpload">
      <i class="el-icon-plus"></i>
    </div>

    <input type="file" ref="fileInput" class="file-input" accept="image/*" @change="handleFileChange">
  </div>
</template>

<script>
export default {
  name: 'UploadImage',
  props: {
    imageCount: {
      type: Number,
      default: 1
    },
    defaultImages: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      photos: []
    }
  },
  watch: {
    defaultImages: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.photos = [...newVal]
        }
      }
    },
    photos(newVal) {
      this.$emit('notifyUploadCoverImage', newVal)
    }
  },
  methods: {
    triggerUpload() {
      this.$refs.fileInput.click()
    },
    handleFileChange(event) {
      const files = event.target.files
      if (!files || files.length === 0) return

      const file = files[0]
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error(this.$t('uploadImage.sizeLimit'))
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        this.photos.push(e.target.result)
      }
      reader.readAsDataURL(file)

      // 清空input值，允许重复选择同一文件
      event.target.value = ''
    },
    removeImage(index) {
      this.photos.splice(index, 1)
    },
    clearImages() {
      this.photos = []
    },
    getImages() {
      return this.photos
    },
    setImages(images) {
      this.clearImages()
      images.forEach(image => {
        if (image.indexOf('base64,') > -1) {
          this.photos.push(image)
          return
        }
        if (image.indexOf('http') > -1) {
          this.photos.push(image)

          return
        }
      })
    }
  }
}
</script>

<style scoped>
.upload-image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-item {
  position: relative;
  width: 100px;
  height: 100px;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}

.delete-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  color: #f56c6c;
  background: #fff;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.upload-button {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #8c939d;
  font-size: 24px;
  background-color: #fbfdff;
}

.upload-button:hover {
  border-color: #409eff;
}

.file-input {
  display: none;
}
</style>